/**
 * Casio fx-991EX — Unit Conversion Data
 * QSG p.7–8: SHIFT+8 (CONV) menu
 * Each category has pairs: [name, factor-to-SI, SI-unit]
 */

const CONV_CATEGORIES = [
  {
    id: 1, name: 'Length', pairs: [
      { id: 1, label: 'in : cm',   from: 'in',  to: 'cm',  factor: 2.54 },
      { id: 2, label: 'cm : in',   from: 'cm',  to: 'in',  factor: 1 / 2.54 },
      { id: 3, label: 'ft : m',    from: 'ft',  to: 'm',   factor: 0.3048 },
      { id: 4, label: 'm : ft',    from: 'm',   to: 'ft',  factor: 1 / 0.3048 },
      { id: 5, label: 'yd : m',    from: 'yd',  to: 'm',   factor: 0.9144 },
      { id: 6, label: 'm : yd',    from: 'm',   to: 'yd',  factor: 1 / 0.9144 },
      { id: 7, label: 'mi : km',   from: 'mi',  to: 'km',  factor: 1.609344 },
      { id: 8, label: 'km : mi',   from: 'km',  to: 'mi',  factor: 1 / 1.609344 },
      { id: 9, label: 'n mi : m',  from: 'nmi', to: 'm',   factor: 1852 },
      { id:10, label: 'm : n mi',  from: 'm',   to: 'nmi', factor: 1 / 1852 },
      { id:11, label: 'pc : km',   from: 'pc',  to: 'km',  factor: 3.0856776e13 },
      { id:12, label: 'km : pc',   from: 'km',  to: 'pc',  factor: 1 / 3.0856776e13 },
    ]
  },
  {
    id: 2, name: 'Area', pairs: [
      { id: 1, label: 'acre : m²',  from: 'acre', to: 'm²',  factor: 4046.8564224 },
      { id: 2, label: 'm² : acre',  from: 'm²',  to: 'acre', factor: 1 / 4046.8564224 },
      { id: 3, label: 'ha : m²',    from: 'ha',   to: 'm²',  factor: 10000 },
      { id: 4, label: 'm² : ha',    from: 'm²',   to: 'ha',  factor: 1 / 10000 },
    ]
  },
  {
    id: 3, name: 'Volume', pairs: [
      { id: 1, label: 'gal(US) : L', from: 'galUS', to: 'L',    factor: 3.785411784 },
      { id: 2, label: 'L : gal(US)', from: 'L',     to: 'galUS', factor: 1 / 3.785411784 },
      { id: 3, label: 'gal(UK) : L', from: 'galUK', to: 'L',    factor: 4.54609 },
      { id: 4, label: 'L : gal(UK)', from: 'L',     to: 'galUK', factor: 1 / 4.54609 },
    ]
  },
  {
    id: 4, name: 'Mass', pairs: [
      { id: 1, label: 'oz : g',    from: 'oz',  to: 'g',   factor: 28.349523125 },
      { id: 2, label: 'g : oz',    from: 'g',   to: 'oz',  factor: 1 / 28.349523125 },
      { id: 3, label: 'lb : kg',   from: 'lb',  to: 'kg',  factor: 0.45359237 },
      { id: 4, label: 'kg : lb',   from: 'kg',  to: 'lb',  factor: 1 / 0.45359237 },
    ]
  },
  {
    id: 5, name: 'Speed', pairs: [
      { id: 1, label: 'km/h : m/s', from: 'kmh', to: 'ms',  factor: 1 / 3.6 },
      { id: 2, label: 'm/s : km/h', from: 'ms',  to: 'kmh', factor: 3.6 },
    ]
  },
  {
    id: 6, name: 'Pressure', pairs: [
      { id: 1, label: 'atm : Pa',  from: 'atm', to: 'Pa',  factor: 101325 },
      { id: 2, label: 'Pa : atm',  from: 'Pa',  to: 'atm', factor: 1 / 101325 },
      { id: 3, label: 'mmHg : Pa', from: 'mmHg', to: 'Pa', factor: 133.322387415 },
      { id: 4, label: 'Pa : mmHg', from: 'Pa', to: 'mmHg', factor: 1 / 133.322387415 },
    ]
  },
  {
    id: 7, name: 'Temperature', pairs: [
      { id: 1, label: '°F : °C', from: '°F', to: '°C', special: 'F_to_C' },
      { id: 2, label: '°C : °F', from: '°C', to: '°F', special: 'C_to_F' },
    ]
  },
  {
    id: 8, name: 'Energy', pairs: [
      { id: 1, label: 'J : cal',   from: 'J',   to: 'cal',  factor: 1 / 4.1868 },
      { id: 2, label: 'cal : J',   from: 'cal', to: 'J',    factor: 4.1868 },
      { id: 3, label: 'J : eV',    from: 'J',   to: 'eV',   factor: 6.241509074e18 },
      { id: 4, label: 'eV : J',    from: 'eV',  to: 'J',    factor: 1.602176634e-19 },
    ]
  },
  {
    id: 9, name: 'Power', pairs: [
      { id: 1, label: 'hp : kW',  from: 'hp',  to: 'kW',  factor: 0.745699872 },
      { id: 2, label: 'kW : hp',  from: 'kW',  to: 'hp',  factor: 1 / 0.745699872 },
    ]
  },
];

export function convertValue(value, categoryId, pairId) {
  const cat = CONV_CATEGORIES.find(c => c.id === categoryId);
  if (!cat) throw new Error('Argument ERROR');
  const pair = cat.pairs.find(p => p.id === pairId);
  if (!pair) throw new Error('Argument ERROR');

  if (pair.special === 'F_to_C') return (value - 32) * 5 / 9;
  if (pair.special === 'C_to_F') return value * 9 / 5 + 32;
  return value * pair.factor;
}

export { CONV_CATEGORIES };
